// extracted by css-extract-rspack-plugin
export default {"fullWidth":"A9wK11yDlo2Od7V0__fullWidth___"};